import script from "./ProgramOverviewList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramOverviewList.vue?vue&type=script&setup=true&lang=js"

import "./ProgramOverviewList.vue?vue&type=style&index=0&id=c0bf84ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0bf84ae"]])

export default __exports__